import { FC, useState } from 'react';
import { useRouter } from 'next/router';
import { useForm } from 'react-hook-form';
import parseLocale from '@utils/parse-locale';
import { useTranslation as t } from '@utils/hooks';
import Input from '@components/Input';
import Button from '@components/Button';
import { ZENDESK_ARTICLES_URL } from '@constants';
import * as styles from './styles';

type FormData = {
  query: string;
};

const SearchForm: FC = () => {
  const { locale, defaultLocale } = useRouter();
  const parsedLocale = parseLocale(defaultLocale, locale);
  const langForZendesk = parsedLocale[0] === 'en' ? 'en-us' : parsedLocale[0];

  const { register, handleSubmit, formState } = useForm<FormData>();

  const { errors } = formState;

  const [loading, setLoading] = useState(false);

  const onSubmit = async (data: FormData): Promise<void> => {
    try {
      setLoading(true);
      window.location.href = `${ZENDESK_ARTICLES_URL.replace(
        'en-us',
        langForZendesk
      )}/search?utf8=✓&query=${data.query}`;
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };

  return (
    <>
      <h2 className={styles.heading}>{t('search_support_articles')}</h2>
      <form className={styles.formWrapper} onSubmit={handleSubmit(onSubmit)}>
        <Input
          id="query"
          type="text"
          inputLabel={t('label_search_for_help_articles')}
          srOnlyLabel
          labelFor="query"
          {...register('query', {
            required: true,
          })}
          requiredError={errors.query && errors.query.type === 'required'}
          classes={{
            inputClass: '!flex-auto !min-w-0 !w-auto !flex w-full !mt-0',
            labelClass: '!flex-auto !min-w-0 !w-auto !flex',
          }}
        />
        <Button
          type="submit"
          buttonStyle="secondary"
          className={styles.contactButton}
          disabled={loading}
        >
          Search
        </Button>
      </form>
    </>
  );
};

export default SearchForm;
